// Target site ID
export const DOM_ID = 'react-microsite';

// Localstorage
// -- also used for persistStore
export const LOCAL_STORAGE_NAME = 'sesame_workshop_outdoor_learning_hub';

export const SEARCH_TAGS = {
  minutes: { minutes_1: '<5', minutes_2: '5 to 20', minutes_3: '>20' },
  players: { players_1: '1', players_2: '2 to 4', players_3: '> 5' },
  play_type: { play_type_1: 'Active', play_type_2: 'Sensory', play_type_3: 'Open', play_type_4: 'Imaginative' },
  activity: { activity_1: 'Time to Transition', activity_2: "Let's Get Moving", activity_3: 'Calm and Collected' },
};
